/**
 * Hub jobs still in Estimating or Preconstruction jump to Under Contract on sign.
 * Estimating skips Preconstruction. Already-contracted and completed jobs are left alone.
 */
export function shouldPromoteTimberPhaseToContractedOnSign(
  phase?: string | null,
): boolean {
  return phase === 'estimating' || phase === 'preconstruction';
}
